import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-detail-three',
  templateUrl: './listing-detail-three.component.html',
  styleUrls: ['./listing-detail-three.component.css']
})
export class ListingDetailThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
